import { updateVitals } from "../../api/historyService";

export const useUpdateVitals = (successCallback) => {
  const update = async (id, data) => {
    try {
        const updatedRecord = await updateVitals(id, data);
        if (successCallback) successCallback(updatedRecord);
        return updatedRecord;
    } catch (error) {
        console.error("Failed to update vitals:", error);
        throw error;
    }
  };

  return { update };
};